<ng-container *ngIf="id" class="form-group m-form__group m-form__group--colored m--margin-top-15 m--padding-15">
  <div *ngIf="!isLoading.list" class="m--padding-right-15">
    <h5 class="m--margin-bottom-15 m--margin-top-15">{{ 'suppliers-bank.banks' | transloco }}</h5>
  </div>
  <div class="form-group m-form__group row m--padding-top-15" style="padding-bottom: 0;" *ngFor="let item of list; let i = index">
    <div class="col-lg-3 col-md-3 col-sm-8">
      <hx-bank-select [(ngModel)]="item.bank.id"></hx-bank-select>
    </div>

    <div class="col-lg-2 col-md-2 col-sm-8">
      <input type="text" class="form-control m-input" [(ngModel)]="item.beneficiaryCode" [placeholder]="'suppliers-bank.kbe' | transloco">
    </div>

    <div class="col-lg-2 col-md-2 col-sm-8">
      <hx-enum-select [(ngModel)]="item.currency" enumName="Currency" [enumType]="Currency"></hx-enum-select>
    </div>

    <div class="col-lg-4 col-md-4 col-sm-12">
      <div class="input-group">
        <input type="text" class="form-control m-input" [(ngModel)]="item.iban" [placeholder]="'suppliers-bank.iban' | transloco">

        <span class="input-group-btn">
          <button [ngbTooltip]="'suppliers-bank.save' | transloco" (click)="updateData(item)" class="btn btn-success btn-thin" type="button">
            <i class="la la-save"></i>
          </button>
        </span>

        <span class="input-group-btn">
          <button [ngbTooltip]="'suppliers-bank.save' | transloco" (click)="removeField(item, i)" class="btn btn-danger btn-thin" type="button">
            <i class="la la-trash"></i>
          </button>
        </span>
      </div>
    </div>
  </div>

  <div class="form-group m-form__group row m--padding-top-15">
    <div class="col-sm-12 text-right">
      <button [title]="'suppliers-bank.add' | transloco" (click)="addItem()" class="btn btn-success" type="button">
        <span>
          <i class="la la-plus"></i>
          <span>{{ 'suppliers-bank.btn.addBanks' | transloco }}</span>
        </span>
      </button>
    </div>
  </div>

  <div *ngIf="isLoading.list" class="m-page-loader m-page-loader--non-block m-page-loader--relative">
    <div class="m-loader m-loader--brand"></div>
  </div>
</ng-container>
